import { render, staticRenderFns } from "./GroupCreateOrEditForm.vue?vue&type=template&id=df768720&scoped=true&"
import script from "./GroupCreateOrEditForm.vue?vue&type=script&lang=js&"
export * from "./GroupCreateOrEditForm.vue?vue&type=script&lang=js&"
import style0 from "./GroupCreateOrEditForm.vue?vue&type=style&index=0&id=df768720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df768720",
  null
  
)

export default component.exports